import { call, fetchAllPages } from '../../shared/api.ts'
import type { apiBid, apiDto } from '@rs/contracts'

/**
 * ══ CỬA GỌI REST — 📣 MỞ THẦU THEO ĐƠN (F28 · `VendorBiddingView` / `NccPortal` tab Chào giá) ══════════════════════════════════
 * Mọi luật (hạn nhận chào giá · ≥ 3 chào giá bắt buộc lý do · tạo NCC theo MST · thầu phụ chỉ thấy giá của mình) nằm ở máy chủ.
 */
export type BiddingBoard = apiDto.BiddingBoardDto
export type BoardRow = BiddingBoard['rows'][number]
/** Chào giá trên bảng mở thầu — `amount` null khi người đọc không xem được giá vốn (E16). */
export type BidOffer = BoardRow['offers'][number]
export type MyBid = apiDto.MyBidDto
export type OpenBiddingResult = apiDto.OpenBiddingResultDto
export type BidPickResult = apiDto.BidPickResultDto

const OPS = '/api/v1/az/chao-gia'
const PORTAL = '/api/v1/ncc/chao-gia'

export const fetchBiddingBoard = (): Promise<BiddingBoard> => call<BiddingBoard>('/api/v1/az/mo-thau/bang')

export const openBiddingApi = (jobIds: readonly string[]): Promise<OpenBiddingResult> =>
  call<OpenBiddingResult>('/api/v1/az/mo-thau', { method: 'POST', body: JSON.stringify({ jobIds }) })

export const closeBiddingApi = (id: string, version: number): Promise<void> =>
  call<void>(`${OPS}/${id}/dong`, { method: 'POST', body: JSON.stringify({ version }) })

export const reopenBiddingApi = (id: string, version: number): Promise<void> =>
  call<void>(`${OPS}/${id}/mo-lai`, { method: 'POST', body: JSON.stringify({ version }) })

export const pickOfferApi = (id: string, body: apiBid.PickOfferBodyT): Promise<BidPickResult> =>
  call<BidPickResult>(`${OPS}/${id}/chon`, { method: 'POST', body: JSON.stringify(body) })

/* ── CỔNG THẦU PHỤ ─────────────────────────────────────────────────────────────────────────── */

export const fetchMyBids = (): Promise<MyBid[]> => fetchAllPages<MyBid>(`${PORTAL}?limit=200`)

export const submitOfferApi = (body: apiBid.SubmitOfferBodyT): Promise<void> =>
  call<void>(`${PORTAL}/bo-gia`, { method: 'POST', body: JSON.stringify(body) })

export const withdrawOfferApi = (requestId: string): Promise<void> =>
  call<void>(`${PORTAL}/rut-gia`, { method: 'POST', body: JSON.stringify({ requestId }) })
